module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "user-item",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.showSendMessage) ? _c('send-message', {
    attrs: {
      "receiver": _vm.userItem,
      "dismiss": _vm.dismissMessageModal
    }
  }) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "user-item-body",
    class: {
      'last-item': _vm.last
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "user-item-section",
    class: {
      sm6: _vm.userItem.recent_reposts,
      'no-reposts': !_vm.userItem.recent_reposts,
    },
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-flex', {
    staticClass: "user-item-section-body",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "user-item-profile-avatar-area"
  }, [_c('router-link', {
    attrs: {
      "to": '/' + _vm.userItem.slug
    }
  }, [_c('div', {
    staticClass: "user-item-profile-avatar",
    style: ({
      'background-image': 'url(' + _vm.userItem.avatar.thumb.url + ')',
    })
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "user-item-content-area"
  }, [_c('div', {
    staticClass: "user-item-content"
  }, [_c('router-link', {
    staticClass: "user-name",
    attrs: {
      "to": '/' + _vm.userItem.slug
    }
  }, [_vm._v(_vm._s(_vm.userItem.username))]), _vm._v(" \n              "), (_vm.userItem.user_type == 'artist') ? _c('v-icon', {
    staticClass: "user-status",
    class: {
      online: _vm.userItem.status == 'active'
    }
  }, [_vm._v("fa-check-circle")]) : _vm._e(), _vm._v(" \n              "), _c('label', {
    staticClass: "follower-count"
  }, [_c('strong', [_vm._v("2.8k")]), _vm._v(" Followers")])], 1), _vm._v(" "), _c('div', {
    staticClass: "actions-section"
  }, [(
    _vm.$store.state.auth.user &&
    _vm.userItem.id != _vm.$store.state.auth.user.id
  ) ? _c('user-follow-btn', {
    attrs: {
      "user": _vm.userItem,
      "theme": "dark",
      "type": "default"
    },
    on: {
      "afterFollow": _vm.afterFollow
    }
  }) : _vm._e(), _vm._v(" "), _c('v-menu', {
    staticClass: "more-menu",
    attrs: {
      "offset-y": ""
    }
  }, [_c('v-btn', {
    staticClass: "more-btn",
    attrs: {
      "slot": "activator",
      "dark": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("more_horiz")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    key: "message"
  }, [_c('v-list-tile-title', {
    staticClass: "default-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.showMessageDialog()
      }
    }
  }, [_c('label', [_vm._v("Message")])])], 1), _vm._v(" "), _c('v-list-tile', {
    key: "blockuser"
  }, [_c('v-list-tile-title', {
    staticClass: "default-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.blockUser()
      }
    }
  }, [_c('label', [_vm._v("Block User")])])], 1)], 1)], 1)], 1)])])], 1), _vm._v(" "), (_vm.userItem.recent_reposts) ? _c('v-flex', {
    staticClass: "user-item-recent-posts",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('p', {
    staticClass: "recent-posts-section-title"
  }, [_vm._v("Recent reposts")]), _vm._v(" "), _vm._l((_vm.userItem.recent_reposts), function(repost, index) {
    return _c('div', {
      key: index,
      staticClass: "recent-post-item",
      style: ({
        'background-image': 'url(' + _vm.imageURL(_vm.userItem.assoc) + ')',
      })
    }, [(repost.album_type) ? _c('router-link', {
      attrs: {
        "to": '/album/' + repost.slug
      }
    }) : _vm._e(), _vm._v(" "), (!repost.album_type) ? _c('router-link', {
      attrs: {
        "to": "/"
      }
    }) : _vm._e()], 1)
  })], 2) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2308f6fd","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/useritem.vue
// module id = 1651
// module chunks = 180